import { FileCheck2, Globe2, Instagram, Mail, Phone } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import LeadForm from "../components/LeadForm";
import { useLeadModal } from "../components/ConversionContactModal";
import { CONTACT_LINKS, FINAL_CTA_IMAGE } from "../lib/protocols";
import { PHONE_OFFICE } from "../lib/api";

const ICONS = { phone: Phone, mail: Mail, "file-check-2": FileCheck2, instagram: Instagram, "globe-2": Globe2 };

export function ContattiSection() {
  const openLead = useLeadModal();

  return (
    <section id="contatti" className="section" data-testid="contatti-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="Contatti"
          title={<>IL CLIENTE AL CENTRO. <span className="gold-text">SEMPRE.</span></>}
          lead="Un unico punto di riferimento per ogni esigenza immobiliare. Scrivi, chiama o lascia la richiesta: la direzione ti risponde di persona."
        />

        <div className="mt-14 grid gap-10 lg:grid-cols-2 lg:gap-14">
          <div className="grid content-start gap-10">
            <div className="grid grid-cols-1 gap-px border border-[#c9a45c]/22 bg-[#c9a45c]/22 sm:grid-cols-2" data-testid="contact-links-grid">
              {CONTACT_LINKS.map((c) => {
                const Icon = ICONS[c.icon] || Mail;
                return (
                  <a
                    key={c.testid}
                    href={c.href}
                    {...(c.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    data-testid={c.testid}
                    className="group flex min-h-[88px] items-center gap-4 bg-[#0b0b0b] px-6 py-5 text-[13px] text-cream transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#151515] hover:text-gold-light"
                  >
                    <Icon size={17} strokeWidth={1.6} className="shrink-0 text-gold" />
                    <span>{c.label}</span>
                  </a>
                );
              })}
            </div>
            <Reveal delay={0.1}>
              <div className="border border-[#c9a45c]/25 bg-[#0d0d0d] p-7" data-testid="contatti-direct">
                <p className="eyebrow">Riservatezza</p>
                <p className="mt-4 text-[14px] leading-relaxed text-[#c9c6bf]">
                  Ogni richiesta viene trattata direttamente dalla direzione, senza intermediari né passaggi
                  interni. Se preferisci il contatto diretto:
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <a href={PHONE_OFFICE} data-testid="contatti-call-button" className="btn btn-outline !min-h-[42px] !px-5 !text-[9px]">
                    <Phone size={12} /> Chiama ora
                  </a>
                  <button data-testid="contatti-lead-button" onClick={() => openLead()} className="btn btn-gold !min-h-[42px] !px-5 !text-[9px]">
                    Richiedi il tuo percorso
                  </button>
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="border border-[#c9a45c]/30 bg-[#0d0d0d] p-7 sm:p-9" data-testid="contatti-form-card">
              <p className="eyebrow">Richiedi il tuo percorso</p>
              <h3 className="display mt-4 text-2xl sm:text-3xl">Raccontaci il tuo obiettivo.</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#929292]">
                Due passaggi, meno di un minuto. Ti ricontattiamo con una prima analisi del tuo caso.
              </p>
              <div className="mt-8">
                <LeadForm sourcePage="contatti" />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export function FinalCtaSection() {
  const openLead = useLeadModal();

  return (
    <section id="final-cta" className="relative overflow-hidden" data-testid="final-cta-section">
      <img
        src={FINAL_CTA_IMAGE}
        alt="Scalinata in marmo con ringhiera dorata"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ filter: "grayscale(0.8) brightness(0.26)" }}
      />
      <div className="absolute inset-0 bg-black/55" />
      <div className="container-hub relative py-28 text-center sm:py-36">
        <Reveal>
          <p className="eyebrow eyebrow-center justify-center">Il punto di partenza</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="display mx-auto mt-6 max-w-[900px] text-4xl text-cream sm:text-5xl lg:text-[64px]" data-testid="final-title">
            IL TUO OBIETTIVO IMMOBILIARE. <span className="gold-text">LA NOSTRA REGIA.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="lead mx-auto mt-7 max-w-[620px] text-[#dedbd4]" data-testid="final-copy">
            Raccontaci cosa vuoi ottenere: costruiamo insieme il percorso più adatto, con un'analisi riservata
            e senza impegno.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <button data-testid="final-lead-cta" onClick={() => openLead()} className="btn btn-gold !px-8">
              Richiedi il tuo percorso
            </button>
            <a href={PHONE_OFFICE} data-testid="final-call-cta" className="btn btn-outline !px-8">
              Parla con A.C. HUB
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
